import CopyButton from './lib/copy-button';
import ProductCarousel from './lib/product-carousel';
import RecipeCarousel from './lib/recipe-carousel';

import './scss/recipe.scss';

CopyButton.createFromSelector('button[data-copy]');
ProductCarousel.createFromSelector('.js-products-carousel');
RecipeCarousel.createFromSelector('.js-recipes-carousel');
